import { simple } from 'src/utils/reducers';

import * as query from './reducers/query';
import * as update from './reducers/update';

// eslint-disable-next-line import/no-default-export
export default simple({
    FRAUD_AND_COMPLIANCE_QUERY_REQUEST: query.request,
    FRAUD_AND_COMPLIANCE_QUERY_ERROR: query.error,
    FRAUD_AND_COMPLIANCE_QUERY_FINISH: query.finish,

    FRAUD_AND_COMPLIANCE_UPDATE_REQUEST: update.request,
    FRAUD_AND_COMPLIANCE_UPDATE_ERROR: update.error,
    FRAUD_AND_COMPLIANCE_UPDATE_FINISH: update.finish,
});
